
export default {
  name: 'BaseProfileAuthorCompetitors',
  props: {
    username: {
      type: String,
      default: null,
    },
    users: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      lead: {
        title: 'Заказать обратный звонок',
        description:
          'Наш специалист свяжется с вами и ответит на любые ваши вопросы',
        data: {
          title:
            'Пользователь хочет скрыть блок "Похожие компании" в своём профиле',
          to: 'forbusiness',
          type: 'CALL',
          level: 'BUSINESS',
          body: null,
          source: {
            position: 'Кнопка в блоке "Похожие компании в профиле компании"',
            chapter: 'Профиль компании',
            source: `https://megasreda.ru${this.$route.path}`,
          },
        },
      },
    }
  },

  computed: {
    isOwner() {
      return this.$auth.loggedIn && this.$auth.user?.username === this.username
    },
  },
  methods: {
    sendLid() {
      this.$refs.competitorsForm.open()
    },
  },
}
